import { useEffect } from 'react'
import { logFrontendRuntimeEvent } from '@emporion/ui'
import type { RuntimeHomeSettings } from '../../runtimeSettings'
import type { Slide } from '../../types'
import { fetchSettingsSlidesAndHomepage } from '../shopRuntimeApi'

type Params = {
  loadHomePage: (slug: string) => Promise<void>
  setSlides: (slides: Slide[]) => void
  setHomeSettings: (settings: RuntimeHomeSettings) => void
  setStatus: (status: string) => void
  setHomepageSlug: (slug: string) => void
}

export const useHomeRuntimeBootstrap = ({
  loadHomePage,
  setSlides,
  setHomeSettings,
  setStatus,
  setHomepageSlug,
}: Params) => {
  useEffect(() => {
    const loadSettingsAndSlides = async () => {
      try {
        const {
          slides: remoteSlides,
          homepageSlug: nextHomepageSlug,
          status: nextStatus,
          settings: nextSettings,
        } = await fetchSettingsSlidesAndHomepage()

        if (remoteSlides.length) {
          setSlides(remoteSlides)
        }
        setHomeSettings(nextSettings)
        setStatus(nextStatus)
        setHomepageSlug(nextHomepageSlug)
        void loadHomePage(nextHomepageSlug)
      } catch (error) {
        logFrontendRuntimeEvent({
          app: 'shop',
          level: 'warn',
          event: 'home_runtime.bootstrap_failed',
          message: 'Failed to load homepage runtime settings',
          error,
        })
        setStatus('Backend non raggiungibile: uso slide di fallback.')
      }
    }

    void loadSettingsAndSlides()
  }, [loadHomePage, setHomeSettings, setHomepageSlug, setSlides, setStatus])
}
